import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import fetchWithAuth from "../fetchWithAuth";

export default function ProjectNotices({ projectId }) {
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const response = await fetchWithAuth(`/api/project-notices${projectId ? `?projectId=${projectId}` : ""}`);
        if (response.ok) {
          const data = await response.json();
          if (active) setNotices(data);
        }
      } catch (error) { console.error("Ошибка загрузки уведомлений", error); }
    };
    load();
    const timer = setInterval(load, 5000);
    return () => { active = false; clearInterval(timer); };
  }, [projectId]);
  const dismiss = async id => {
    const response = await fetchWithAuth(`/api/project-notices/${id}/dismiss`, { method: "POST" });
    if (response.ok) setNotices(current => current.filter(notice => notice.id !== id));
  };
  if (!notices.length) return null;
  return <div className="space-y-3" aria-label="Уведомления проектов">
    {notices.map(notice => <div key={notice.id} role="alert"
      className={`flex items-start gap-3 rounded-lg border-l-4 p-4 shadow-sm ${notice.severity === "warning" ? "border-amber-500 bg-amber-50 text-amber-900" : "border-red-600 bg-red-50 text-red-900"}`}>
      <AlertTriangle className="h-6 w-6 shrink-0 mt-0.5" aria-hidden="true" />
      <div className="flex-1">
        <p className="font-bold">Проблема сбора аналитики{!projectId && <> — <Link className="underline" to={`/project/${notice.projectId}`}>{notice.project.name}</Link></>}</p>
        <p className="mt-1 text-sm">{notice.message}</p>
      </div>
      <button type="button" aria-label={`Скрыть уведомление проекта ${notice.project.name}`} className="rounded p-1 hover:bg-black/5" onClick={() => dismiss(notice.id)}>
        <X className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>)}
  </div>;
}
